import { render } from "./EditForkliftNote.vue?vue&type=template&id=54ceec69&scoped=true"
import script from "./EditForkliftNote.vue?vue&type=script&lang=js"
export * from "./EditForkliftNote.vue?vue&type=script&lang=js"

import "./EditForkliftNote.vue?vue&type=style&index=0&id=54ceec69&lang=css"
import "./EditForkliftNote.vue?vue&type=style&index=1&id=54ceec69&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54ceec69"]])

export default __exports__